import React, { FC, ReactNode, useEffect, useState } from 'react';
import { RoleContext } from './context';
import { STORAGE_KEYS } from 'utils/constants';
import { ENUM_ROLE } from '@cokitchen/cokitchen-auth';

const RoleProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [role, setRole] = useState<ENUM_ROLE>();
  const [isMainAdmin, setIsMainAdmin] = useState(false);

  useEffect(() => {
    const storeRole = localStorage.getItem(STORAGE_KEYS.ROLE) as ENUM_ROLE;
    if (storeRole) setRole(storeRole);

    const adminRole = localStorage.getItem(STORAGE_KEYS.ADMIN_ROLE) as ENUM_ROLE;
    const isAdmin = [ENUM_ROLE.ADMIN, ENUM_ROLE.SUPER_ADMIN, ENUM_ROLE.DEVELOPER].includes(
      adminRole
    );
    setIsMainAdmin(isAdmin);
  }, []);

  return (
    <RoleContext.Provider
      value={{
        role,
        setRole,
        isMainAdmin,
        setIsMainAdmin
      }}>
      {children}
    </RoleContext.Provider>
  );
};

export default RoleProvider;
